"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FrozenPanes = void 0;
const mithril_1 = __importDefault(require("mithril"));
const delayed_1 = require("../utils/delayed");
class FrozenPanes {
    constructor(opts) {
        this.leftWidth = 0;
        this.topHeight = 0;
        this.leftOffset = 0;
        this.topOffset = 0;
        this.contentWidth = 0;
        this.contentHeight = 0;
        this.updatePanes = (dom) => {
            this.leftWidth = this.left.offsetWidth;
            this.topHeight = this.top.offsetHeight;
            this.leftOffset = dom.scrollLeft;
            this.topOffset = dom.scrollTop;
            this.contentWidth = this.content.offsetWidth;
            this.contentHeight = this.content.offsetHeight;
        };
        this.oncreate = (vnode) => {
            let dom = vnode.dom;
            this.left = dom.getElementsByClassName("fp-left")[0];
            this.top = dom.getElementsByClassName("fp-top")[0];
            this.content = dom.getElementsByClassName("fp-content")[0];
        };
        this.onupdate = (vnode) => {
            let dom = vnode.dom;
            this.updatePanes(dom);
        };
        this.onscroll = (evt) => {
            (0, delayed_1.delayed)("frozen-pane", () => {
                this.updatePanes(evt.target);
                mithril_1.default.redraw();
            }, 40);
            evt.redraw = false;
        };
        this.computeContainerStyle = () => {
            return [
                `padding-top: ${this.topHeight}px`,
                `padding-left: ${this.leftWidth}px`
            ].join(";");
        };
        this.computeLeftStyle = () => {
            return `padding-top: ${this.topHeight}px; min-height: ${this.contentHeight + this.topHeight}px; left: ${this.leftOffset}px`;
        };
        this.computeTopStyle = () => {
            return `padding-left: ${this.leftWidth}px; min-width: ${this.contentWidth}px;  top: ${this.topOffset}px`;
        };
        this.view = (vnode) => {
            return (0, mithril_1.default)(".fp-container", { style: this.computeContainerStyle(), onscroll: this.onscroll }, (0, mithril_1.default)(".fp-left", { style: this.computeLeftStyle() }, this.opts.left && this.opts.left()), (0, mithril_1.default)(".fp-top", { style: this.computeTopStyle() }, this.opts.top && this.opts.top()), (0, mithril_1.default)(".fp-content", {}, this.opts.content()));
        };
        this.opts = opts;
    }
}
exports.FrozenPanes = FrozenPanes;
